<!-- 博彩责任 -->
<template>
    <div class="responsibility">
        <div class="titleBOx">
               <h2 class="title">
                {{help.name20}}
            </h2>
        </div>
        <div class="content"> 
            <h3 class="tip1"> {{help.name34}}</h3>
            <p class="tip2">{{help.name35}} </p>
            <p class="tip2">{{help.name36}} </p>
            <p class="tip2">{{help.name37}}</p>
            <p class="tip2">{{help.name38}}</p>

            <h3 class="tip1">{{help.name39}}</h3>
            <p class="tip2">{{help.name40}}</p>

            <p class="tip2">{{help.name400}}</p>
            <p class="tip2">{{help.name41}}</p>
            <p class="tip2">{{help.name42}}</p>
            <p class="tip2">{{help.name43}}</p>
            <p class="tip2">{{help.name44}}</p>
            <p class="tip2">{{help.name45}}</p>
            <p class="tip2">{{help.name46}}</p>
            <p class="tip2">{{help.name47}}</p>
            <p class="tip2" style="margin-bottom:20px">{{help.name48}}</p>

            <p class="tip2">{{help.name49}}</p>
            <p class="tip2" style="margin-bottom:10px">{{help.name50}}</p>
            <p class="tip2">{{help.name51}}</p>
            <p class="tip2">{{help.name52}}</p>
            <p class="tip2">{{help.name53}}</p>

             <h3 class="tip1">{{help.name54}}</h3>
             <p class="tip2">{{help.name55}}</p>


        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
        }
    },
    computed: {
        help() {
            return this.$t('help')
        }
    },
    methods:{
    },
    mounted(){

    }
}
</script>
<style scoped lang='scss'>
    .responsibility{
        .titleBOx{
            border-bottom: 2px solid #f0f0f0;
            width: 100%;
            height: 60px;
            .title{
                line-height: 60px;
                margin-left: 30px;
                font-size: 24px;
                font-weight: 200;
                color: #e21;
            }
        }
        .content{
            padding: 30px 30px 50px;
            .tip1{
                padding: 15px 0px 20px;
                line-height: 30px;
                font-size: 18px;
                font-weight: 500;
            }
            .tip2{
                line-height: 32px;
                font-size: 14px;
                color: #666;
                text-indent: 2em;
                .tip3{
                    color: #ec2828;
                }
            }
        }
    }
</style>